<template>
	<div>
		<h4 class="mb-3">{{ $t('import-results') }}</h4>
		<div class="card mb-3">
			<div class="card-body">
				<p class="text-success mb-1">{{ $t('users-created') }}: <strong>{{ importResults.created_users }}</strong></p>
				<p class="text-secondary mb-3">{{ $t('users-skipped') }}: <strong>{{ importResults.skipped_users }}</strong></p>

				<div v-if="importResults.skipped_rows && importResults.skipped_rows.length" class="mb-3">
					<p class="font-weight-bold mb-1">{{ $t('skipped-rows') }}</p>
					<div class="table-responsive">
						<table class="table table-sm table-bordered">
							<thead class="thead-light">
								<tr>
									<th style="width:4rem">{{ $t('row') }}</th>
									<th>{{ $t('reason') }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(row, i) in importResults.skipped_rows" :key="i" class="table-warning">
									<td class="text-muted">{{ row.line || '—' }}</td>
									<td class="small">{{ row.reason }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div v-if="importResults.import_warnings && importResults.import_warnings.length" class="mb-3">
					<p class="font-weight-bold mb-1">{{ $t('import-warnings') }}</p>
					<b-table striped hover small responsive :items="importResults.import_warnings"></b-table>
				</div>

				<b-button variant="outline-secondary" class="mt-2" @click="$emit('reset')">
					{{ $t('import-another-file') }}
				</b-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		importResults: { type: Object, required: true },
	},
};
</script>
